import React from 'react'

export const CalendarX: React.FC = () => (
  <path d="M5,22h14c1.103,0,2-0.897,2-2V6c0-1.103-0.897-2-2-2h-2V2h-2v2H9V2H7v2H5C3.897,4,3,4.897,3,6v14C3,21.103,3.897,22,5,22z M15.707,17.293l-1.414,1.414L12,16.414l-2.293,2.293l-1.414-1.414L10.586,15l-2.293-2.293l1.414-1.414L12,13.586l2.293-2.293 l1.414,1.414L13.414,15L15.707,17.293z M5,7h14v2H5V7z" />
)
